export const INVISIBLE = 'INVISIBLE';
export const TEST = 'TEST';
export const VIM_TEAM = 'VIM_TEAM';
export const INCOMING_REFERRAL_USER = 'INCOMING_REFERRAL_USER';
// Nintendo have a specific clinic that should not book, its users have the NINTENDO_CLINIC tag
export const NINTENDO_CLINIC = 'NINTENDO_CLINIC';
